import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import { ResponsiveImage } from '../styles'

export const titleStyles = css`
  margin-bottom: 0;
`

export const wrapperStyles = css`
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  max-width: 700px;
`

export const SmartphonesImage = styled(ResponsiveImage)`
  margin-left: ${({ theme }) => theme.spaces[4] + theme.spaces[3]}px;
  max-width: 400px;

  ${({ theme }) => css`
    ${theme.above.laptopL`
      max-width: 260px;
    `}

    ${theme.below.laptop`
      margin: auto;
    `}
  `}
`

export const Row = styled(Box)`
  flex-direction: row;

  ${({ theme }) => theme.below.laptop`
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spaces[5]}px;
  `}
`
